import { PLACEMENT as BADGE_PLACEMENT } from "baseui/badge";

export enum BADGE_COLOR {
  accent = "accent",
  warning = "warning",
  positive = "positive",
  negative = "negative",
}

export enum BADGE_HIERARCHY {
  low = "low",
  high = "high",
}

export { BADGE_PLACEMENT };
